"use strict";

/************
DIRECTIVE
*************/
Vue.directive('cover', {
  bind: function bind(el, binding, vnode) {
    var img = el.querySelector('img');

    if (img) {
      new Cover(img);
    }
  }
});
"use strict";

/************
MIXINS
*************/
var eventHub = new Vue();
var eventMixin = {
  data: function data() {
    return {
      eventHub: eventHub,
      lang: 'fr'
    };
  },
  computed: {
    langParams: function langParams() {
      return '&lang=' + this.lang;
    }
  },
  methods: {
    setLang: function setLang() {
      if (this.$refs.containerPosts != undefined) {
        var lang = this.$refs.containerPosts.dataset.lang;
        this.lang = lang ? lang : 'fr';
      }
    },
    retrieveFilterFromStorage: function retrieveFilterFromStorage(key) {
      var filters = sessionStorage.getItem('adden_' + key);
      return !filters ? {} : JSON.parse(filters);
    },
    setFilterToStorage: function setFilterToStorage(key, data) {
      sessionStorage.setItem('adden_' + key, JSON.stringify(data));
    },
    emitOpen: function emitOpen() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.eventHub.$emit("".concat(key, ":open"));
    },
    emitClose: function emitClose() {
      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      this.eventHub.$emit("".concat(key, ":close"));
    }
  },
  mounted: function mounted() {
    this.setLang();
  }
};
"use strict";

/************
COMPONENT
*************/
Vue.component('cardNews', {
  template: "\n    <a :href=\"link\"\n      class=\"card card-news is-alpha\"\n      :class=\"{'is-highlighted': highlighted}\">\n      <div class=\"card-thumbnail cover-image js-cover-image has-4-3-ratio has-cover-background\" :style=\"'background-image:url(' + thumbnail.url + ')'\" v-cover>\n          <div class=\"card-content has-white-color is-top\" v-if=\"categories\">\n            <p v-for=\"category in categories\"\n              class=\"card-subtitle has-line\"\n              :class=\"'is-'+category.color\"\n              v-html='category.name'></p>\n          </div>\n          <div class=\"card-content is-bottom\"\n            v-if=\"highlighted\">\n            <p class=\"card-title\" v-html=\"title\"></p>\n            <p class=\"card-date capitalize\">\n              {{ date | moment }}\n            </p>\n          </div>\n        </div>\n        <div class=\"card-content is-bottom\"\n          v-if=\"!highlighted\">\n          <p class=\"card-title\" v-html=\"titleExcerpt\"></p>\n          <p class=\"card-date\">\n            {{ date | moment }}\n          </p>\n        </div>\n    </a>\n  ",
  filters: {
    moment: function (_moment) {
      function moment(_x) {
        return _moment.apply(this, arguments);
      }

      moment.toString = function () {
        return _moment.toString();
      };

      return moment;
    }(function (date) {
      console.log(moment().format());
      console.log(moment(date).locale("fr").format('MMMM YYYY'));
      return moment(date).locale("fr").format('MMMM YYYY');
    })
  },
  props: {
    highlighted: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    titleExcerpt: {
      type: String,
      required: true
    },
    link: {
      type: String,
      required: true
    },
    date: {
      type: Date,
      required: true
    },
    thumbnail: {
      type: [Object, null],
      required: false,
      default: null
    },
    categories: {
      type: [Array, String],
      required: false,
      default: ''
    }
  }
});
"use strict";

/************
COMPONENT
*************/
Vue.component('cardPublication', {
  template: "\n   <div class=\"card card-publication has-hover has-hover-shadow-2\" v-if=\"!link\">\n      <div class=\"card-content flex-column is-justified-between\">\n        <div>\n          <p class=\"card-subtitle\" v-if=\"categories.length\">\n            <span\n              v-for=\"category in categories\"\n              :class=\"'has-' + category.color + '-color'\">{{ category.name }} </span>\n          </p>\n          <p class=\"card-title\" v-html=\"title\"></p>\n        </div>\n        <p>\n          <span v-if=\"content\" v-html=\"content\"></span>\n        </p>\n      </div>\n    </div>\n    <a class=\"card card-publication has-hover has-hover-shadow-2\" :alt=\"title\" :href=\"link\" target=\"blank\" v-else>\n      <div class=\"card-content flex-column is-justified-between\">\n        <div>\n          <p class=\"card-subtitle\" v-if=\"categories.length\">\n            <span\n              v-for=\"category in categories\"\n              :class=\"'has-' + category.color + '-color'\">{{ category.name }} </span>\n          </p>\n          <p class=\"card-title\" v-html=\"title\"></p>\n        </div>\n        <p>\n          <span v-if=\"content\" v-html=\"content\"></span>\n        </p>\n      </div>\n    </a>\n  ",
  props: {
    title: {
      type: String,
      required: false,
      default: ''
    },
    link: {
      type: String,
      required: false,
      default: ''
    },
    categories: {
      type: [Array, String],
      required: false,
      default: ''
    },
    content: {
      type: String,
      required: false,
      default: ''
    },
    authors: {
      type: [Array, String],
      required: false,
      default: ''
    }
  },
  computed: {
    authorsLabel: function authorsLabel() {
      return this.authors ? this.authors.map(function (author) {
        return author.post_title;
      }).join(', ') : '';
    }
  }
});
"use strict";

/************
  COMPONENT
*************/
Vue.component('cardReference', {
  template: "\n  <a :href=\"link\" class=\"card card-reference has-square-ratio relative\">\n    <div class=\"absolute flex-column w-full h-full top-0 left-0\">\n      <div class=\"card-thumbnail cover-image js-cover-image\" v-cover>\n        <img :data-src=\"thumbnail.url\" :alt=\"thumbnail.alt\" :title=\"thumbnail.title\">\n      </div>\n      <div class=\"card-content has-white-color\">\n        <div class=\"\">\n          <h3\n            v-if=\"subhead\"\n            class=\"card-subhead has-white-color\"\n            v-html=\"subhead\">\n          </h3>\n          <h4 class=\"card-title has-white-color\" v-html=\"title\"></h3>\n        </div>\n        <div class=\"card-subtitle flex-row is-justified-between items-center\" >\n          <span>{{ project }}</span>\n          <span>{{ year }}</span>\n        </div>\n      </div>\n    </div>\n  </a>",
  props: {
    subhead: {
      type: String,
      required: false,
      default: ''
    },
    title: {
      type: String,
      required: false,
      default: ''
    },
    project: {
      type: String,
      required: false,
      default: ''
    },
    year: {
      type: String,
      required: false,
      default: ''
    },
    thumbnail: {
      type: [Object, null],
      required: false,
      default: null
    },
    link: {
      type: String,
      required: false,
      default: ''
    }
  }
});
"use strict";

/************
  COMPONENT
*************/
Vue.component('cardTeam', {
  template: "\n   <a :href=\"link\" class=\"card card-team is-white is-center-aligned\">\n    <div class=\"card-thumbnail is-white has-hover has-square-ratio js-cover-image cover-image\"\n      v-cover>\n      <img :data-src=\"thumbnail.url\" :alt=\"thumbnail.alt\" :title=\"thumbnail.title\">\n      <button class=\"button is-square is-rounded is-alpha is-small\">\n        <span class=\"css-icon is-plus is-white\"></span>\n      </button>\n    </div>\n    <div class=\"card-content has-alpha-color\">\n      <p class=\"card-title\">{{ firstName }} {{ lastName }}</p>\n      <p class=\"card-subtitle\">\n        {{ status }}\n        <template v-if=\"cities\"><br/>{{ cities }}</template>\n      </p>\n    </div>\n  </a>",
  props: {
    firstName: {
      type: String,
      required: true
    },
    lastName: {
      type: String,
      required: true
    },
    cities: {
      type: String,
      required: false,
      default: ''
    },
    status: {
      type: String,
      required: false,
      default: ''
    },
    thumbnail: {
      type: [Object, null],
      required: false,
      default: null
    },
    link: {
      type: String,
      required: false,
      default: ''
    }
  }
});
"use strict";

/************
  COMPONENT
*************/
Vue.component('appFilters', {
  template: "\n      <div v-cloak>\n        <button\n        class=\"filters-open button is-alpha\"\n        :class=\"{ 'is-open': isOpen }\"\n        type=\"button\"\n        @click=\"open\">{{ label }}</button>\n        <div class=\"filters\" :class=\"{ 'is-open': isOpen }\">\n          <div class=\"filters-head flex-row items-center is-justified-between\">\n            <p class=\"title-h3\">{{ label }}</p>\n            <button\n              type=\"button\"\n              class=\"button is-square is-small is-rounded is-gray-100\"\n              @click=\"close\">\n              <span class=\"css-icon is-close\"></span>\n            </button>\n          </div>\n          <slot></slot>\n        </div>\n      </div>\n    ",
  mixins: [eventMixin],
  props: {
    label: {
      type: String,
      required: false,
      default: 'Filtrer'
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },
  mounted: function mounted() {
    this.eventHub.$on('filters:close', this.close);
  },
  methods: {
    close: function close() {
      document.body.style.overflow = 'auto';
      this.isOpen = false;
    },
    open: function open() {
      document.body.style.overflow = 'hidden';
      this.isOpen = true;
    }
  }
});
"use strict";

/************
   COMPONENT
 *************/
Vue.component('appInput', {
  template: "\n    <div class=\"form-control\" :class=\"{'is-read-only': readOnly, 'is-error': errors}\">\n      <label class=\"label\" v-if=\"label\">{{label}}</label>\n      <div class=\"form-wrapper\">\n        <input\n        ref=\"field\"\n        class=\"form-field\"\n        :type=\"type\"\n        :name=\"name\"\n        :id=\"name\"\n        :disabled=\"disabled\"\n        :placeholder=\"placeholder\"\n        v-model=\"sync_model\"/>\n        <button\n          v-if=\"resettable\"\n          type=\"button\"\n          class=\"button is-square is-xsmall is-rounded is-gray-100\"\n          @click=\"reset\">\n          <span class=\"css-icon is-close\"></span>\n        </button>\n      </div>\n      <div class=\"form-errors\" v-if=\"errors\">\n        <p v-for=\"error in errors\">{{ error }}</p>\n      </div>\n    </div>\n    ",
  props: {
    label: String,
    name: String,
    placeholder: String,
    model: [String, null],
    type: {
      type: String,
      required: false,
      default: 'text'
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
    errors: {
      type: [Array, null],
      required: false,
      default: function _default() {
        return null;
      }
    },
    delay: {
      type: Number,
      default: 400
    }
  },
  methods: {
    reset: function reset() {
      this.sync_model = '';
      this.$refs.field.focus();
    }
  },
  computed: {
    resettable: function resettable() {
      return this.sync_model && this.clearable;
    },
    sync_model: {
      get: function get() {
        return this.model;
      },
      set: function set(val) {
        var _this = this;

        if (this.unwatch) clearTimeout(this.unwatch);
        this.unwatch = setTimeout(function () {
          _this.$emit('update:model', val);
        }, this.delay);
      }
    }
  }
});
"use strict";

/************
  COMPONENT
*************/
Vue.component('postCounter', {
  template: "",
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data: function data() {
    return {
      url: '/wp-json/wp/v2/posts_count',
      storageKey: 'adden_posts_views',
      postsViewed: []
    };
  },
  computed: {
    // check if post is in postViewed is not in array
    postNotViewed: function postNotViewed() {
      return this.postsViewed.indexOf(this.id) == -1;
    }
  },
  mounted: function mounted() {
    this.checkPostsViewed();
  },
  methods: {
    // get localstorage already viewed posts or return empty array
    getPostsViewed: function getPostsViewed() {
      var postsViewed = localStorage.getItem(this.storageKey);
      return postsViewed ? JSON.parse(postsViewed) : [];
    },
    // save viewed posts to localstorage
    savePostsViewed: function savePostsViewed(res) {
      this.postsViewed.push(this.id);
      localStorage.setItem(this.storageKey, JSON.stringify(this.postsViewed));
    },
    // update post only if it has not been already viewed
    checkPostsViewed: function checkPostsViewed() {
      this.postsViewed = this.getPostsViewed();

      if (this.postNotViewed) {
        this.updatePostView();
      }

      return;
    },
    // update count on api endpoint for current post
    updatePostView: function updatePostView() {
      var _this = this;

      axios({
        method: 'post',
        url: this.url,
        data: {
          'id': this.id
        }
      }).then(function (res) {
        return _this.savePostsViewed(res);
      }).catch(function (err) {
        return console.log(err);
      });
    }
  }
});
"use strict";

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/************
   COMPONENT
 *************/
Vue.component('appSelect', {
  template: "\n    <div\n      class=\"form-control\"\n      :class=\"{'is-read-only': readOnly}\"\n      ref=\"dropdown\">\n        <label class=\"form-label\"\n          :for=\"name\"\n          v-if=\"label\">\n          {{label}}\n        </label>\n        <div class=\"form-select\">\n          <div class=\"form-wrapper\">\n            <select class=\"form-field\"\n              v-if=\"sync_options\"\n              v-model=\"sync_model\"\n              :name=\"name\"\n              :id=\"name\"\n              :disabled=\"disabled\"\n              :class=\"{ 'is-default': isDefault }\">\n              <option\n                v-for=\"(option, index) in sync_options\"\n                :key=\"index\"\n                :value=\"option.id\">\n                {{option.name}}\n              </option>\n            </select>\n            <span class=\"icon-select icon-dropdown\"></span>\n          </div>\n        </div>\n    </div>\n    ",
  props: {
    defaultOption: {
      type: String,
      required: false,
      default: ''
    },
    defaultActiveOption: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    model: {
      required: false,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    options: {
      type: [Array, String],
      required: true
    },
    readOnly: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    delay: {
      type: Number,
      default: 400
    }
  },
  data: function data() {
    return {
      dropdownOpen: false
    };
  },
  computed: {
    sync_model: {
      get: function get() {
        return this.model;
      },
      set: function set(val) {
        var _this = this;

        if (this.unwatch) clearTimeout(this.unwatch);
        this.unwatch = setTimeout(function () {
          _this.$emit('update:model', val);
        }, this.delay);
      }
    },
    sync_options: function sync_options() {
      return [{
        name: this.defaultOption,
        id: ''
      }].concat(_toConsumableArray(this.options));
    },
    isDefault: function isDefault() {
      return this.sync_model == '';
    }
  }
});
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/************
  COMPONENT
*************/
Vue.component('appFiltersChoices', {
  template: "\n      <div>\n        <div class=\"filters-selectors\">\n          <div\n            v-for=\"(field, index) in computedFilters\"\n            class=\"form-control\"\n            ref=\"dropdown\"\n            v-if=\"field.options.length\">\n              <div class=\"form-select\">\n                <div class=\"form-wrapper\">\n                  <select class=\"form-field\"\n                    @change=\"add(field)\"\n                    v-model=\"field.model\">\n                    <option\n                      v-for=\"(option, index) in field.availableOptions\"\n                      :key=\"index\"\n                      :value=\"option.id\">\n                      {{option.name}}\n                    </option>\n                  </select>\n                  <span class=\"icon-select icon-dropdown\"></span>\n                </div>\n              </div>\n          </div>\n        </div>\n\n        <ul class=\"filters-choices\" v-if=\"selectedFilters\">\n          <li v-for=\"filter in selectedFilters\">\n            <button\n              type=\"button\"\n              class=\"button is-outline is-small\"\n              :class=\"getFilterColor(filter.color)\"\n              @click=\"remove(filter.id)\">\n              {{ filter.name }} <span class=\"css-icon is-close\"></span>\n            </button>\n          </li>\n          <li v-if=\"selectedFilters.length >= 1\">\n            <button\n            type=\"button\"\n            class=\"filter-init\"\n            @click=\"reload()\">{{ reinitLabel }}</button>\n          </li>\n        </ul>\n\n      </div>\n    ",
  mixins: [eventMixin],
  props: {
    defaultOptions: {
      type: [Array, String],
      required: false,
      default: ''
    },
    filterFields: {
      type: Array,
      required: true
    },
    values: {
      type: Array,
      required: false,
      default: []
    },
    reinitLabel: {
      type: String,
      required: false,
      default: 'Réinitialiser'
    }
  },
  data: function data() {
    return {
      selectedFilters: []
    };
  },
  watch: {
    filterFields: function filterFields(data) {
      var _this = this;

      Object.keys(data).map(function (k) {
        var name = data[k].name,
            options = data[k].options,
            values = _this.values[name].split(','); // get option obj for savec id if fiters are coming from storage or passed to url


        if (values.length && options.length) {
          values.map(function (v) {
            var found = options.find(function (o) {
              return o.id == v;
            });

            if (found && !_this.isSelected(v)) {
              _this.selectedFilters = [].concat(_toConsumableArray(_this.selectedFilters), [found]);
            }
          });
        }
      });
    }
  },
  computed: {
    computedFilters: function computedFilters() {
      var _this2 = this;

      var filters = this.filterFields.map(function (f, i) {
        var obj = f.options.reduce(function (obj, o) {
          // add value to value if is selected array else to available options
          if (_this2.isSelected(o.id)) {
            obj['value'].push(o.id);
          } else {
            obj['availableOptions'].push(o);
          }

          return obj;
        }, {
          'availableOptions': [{
            name: _this2.getDefaultOption(i),
            id: ''
          }],
          'value': [],
          'model': ''
        }); // add value and available options properties to obj

        return _objectSpread(_objectSpread({}, f), obj);
      });
      return filters;
    },
    filters: function filters() {
      return this.computedFilters.reduce(function (obj, f) {
        obj[f.name] = f.value.join(',');
        return obj;
      }, {});
    }
  },
  mounted: function mounted() {},
  methods: {
    getFilterColor: function getFilterColor(color) {
      return color ? 'is-' + color : 'is-alpha';
    },
    getDefaultOption: function getDefaultOption(index) {
      var parsedLabels = JSON.parse(this.defaultOptions);

      if (parsedLabels[index]) {
        return parsedLabels[index];
      }

      return '';
    },
    isSelected: function isSelected(id) {
      if (!id) return false;
      var index = this.selectedFilters.findIndex(function (f) {
        return f.id == id;
      });
      return index != -1 ? true : false;
    },
    update: function update() {
      this.$emit('filter', this.filters);
    },
    add: function add(field) {
      var opts = field.options.filter(function (o) {
        return o.id == field.model;
      });

      if (field.first) {
        this.selectedFilters = [].concat(_toConsumableArray(opts), _toConsumableArray(this.selectedFilters));
      } else {
        this.selectedFilters = [].concat(_toConsumableArray(this.selectedFilters), _toConsumableArray(opts));
      }

      this.update();
    },
    remove: function remove(id) {
      this.selectedFilters = this.selectedFilters.filter(function (f) {
        return f.id != id;
      });
      this.update();
    },
    reload: function reload() {
      this.selectedFilters = [];
      this.update();
    }
  }
});
"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function animate() {
  window.sr = ScrollReveal();

  var slide = {
    distance: '100px',
    opacity: 0,
    duration: 1500
  },
      slideTop = _objectSpread(_objectSpread({}, slide), {
    origin: 'bottom'
  }),
      slideBottom = _objectSpread(_objectSpread({}, slide), {
    origin: 'top'
  }),
      slideRight = _objectSpread(_objectSpread({}, slide), {
    origin: 'left'
  }),
      slideLeft = _objectSpread(_objectSpread({}, slide), {
    origin: 'right'
  }),
      slideList = _objectSpread(_objectSpread({}, slideTop), {
    interval: 300,
    distance: '50px',
    duration: 1000
  });

  sr.reveal('.js-slide-top', slideTop);
  sr.reveal('.js-slide-bottom', slideBottom);
  sr.reveal('.js-slide-right', slideRight);
  sr.reveal('.js-slide-left', slideLeft);
  sr.reveal('.js-slide-list', slideList);
  sr.reveal('.js-slide-opacity', {
    opacity: 0,
    duration: 1500
  });
  sr.reveal('.js-slide-image', {
    opacity: 0,
    scale: 0.9,
    duration: 1500
  });
  sr.reveal('.js-slide-col', _objectSpread(_objectSpread({}, slideTop), {
    interval: 300
  }));
  sr.reveal('.js-slide-col h2', _objectSpread(_objectSpread({}, slideBottom), {
    delay: 100,
    distance: '50px'
  }));
  sr.reveal('.js-slide-col .wysiwyg ol li', _objectSpread(_objectSpread({}, slideBottom), {
    delay: 1000,
    interval: 500,
    distance: '30px'
  }));
  sr.reveal('.js-slide-col .wysiwyg img', slideTop);
}

animate();

function initLoader() {
  var loader = document.getElementById('loader');

  if (loader) {
    if (!sessionStorage.getItem('loader')) {
      sessionStorage.setItem('loader', true);
      loader.children[0].classList.add('show');
      setTimeout(function () {
        document.body.classList.remove('not-init');
      }, 500);
      setTimeout(function () {
        loader.children[0].classList.remove('show');
        setTimeout(function () {
          loader.parentNode.removeChild(loader);
        }, 500);
      }, 2000);
    } else {
      document.body.classList.remove('not-init');
      loader.parentNode.removeChild(loader);
    }
  }
}

window.addEventListener("DOMContentLoaded", function (event) {
  initLoader();
});
"use strict";

var styles = [{
  "elementType": "geometry",
  "stylers": [{
    "color": "#f2f6fc"
  }]
}, {
  "elementType": "labels",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "elementType": "labels.text",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#616161"
  }]
}, {
  "elementType": "labels.text.stroke",
  "stylers": [{
    "color": "#f5f5f5"
  }]
}, {
  "featureType": "administrative",
  "elementType": "geometry",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "administrative.land_parcel",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "administrative.land_parcel",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#bdbdbd"
  }]
}, {
  "featureType": "administrative.neighborhood",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi",
  "elementType": "geometry",
  "stylers": [{
    "color": "#eeeeee"
  }]
}, {
  "featureType": "poi",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#757575"
  }]
}, {
  "featureType": "poi.park",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "poi.park",
  "elementType": "geometry",
  "stylers": [{
    "color": "#e5e5e5"
  }]
}, {
  "featureType": "poi.park",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}, {
  "featureType": "road",
  "elementType": "geometry",
  "stylers": [{
    "color": "#ffffff"
  }]
}, {
  "featureType": "road",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "road.arterial",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#757575"
  }, {
    "visibility": "off"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "geometry",
  "stylers": [{
    "color": "#f2f6fc"
  }]
}, {
  "featureType": "road.highway",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#616161"
  }, {
    "visibility": "off"
  }]
}, {
  "featureType": "road.local",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}, {
  "featureType": "transit",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit.line",
  "elementType": "geometry",
  "stylers": [{
    "color": "#e5e5e5"
  }]
}, {
  "featureType": "transit.station",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "geometry",
  "stylers": [{
    "color": "#eeeeee"
  }, {
    "visibility": "off"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "labels",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "labels.text",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "transit.station",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#85bfe1"
  }, {
    "weight": 2
  }]
}, {
  "featureType": "transit.station.bus",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit.station.bus",
  "elementType": "geometry",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "transit.station.bus",
  "elementType": "labels.icon",
  "stylers": [{
    "visibility": "off"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry",
  "stylers": [{
    "color": "#6fb6de"
  }, {
    "visibility": "simplified"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry.fill",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "water",
  "elementType": "geometry.stroke",
  "stylers": [{
    "visibility": "simplified"
  }]
}, {
  "featureType": "water",
  "elementType": "labels.text.fill",
  "stylers": [{
    "color": "#9e9e9e"
  }]
}];

function initMap(container, marker) {
  var icon = container.getAttribute('data-icon'),
      iconWidth = 40;
  var map = new google.maps.Map(container, {
    center: marker,
    zoom: 16,
    styles: styles,
    zoomControl: false,
    scaleControl: false,
    streetViewControl: false
  });
  var markerIcon = {
    url: icon,
    size: new google.maps.Size(iconWidth, iconWidth),
    scaledSize: new google.maps.Size(iconWidth, iconWidth)
  };
  var customMarker = new google.maps.Marker({
    position: marker,
    map: map,
    icon: markerIcon
  });
}
"use strict";

window.addEventListener("DOMContentLoaded", function (event) {
  if (document.getElementById("vue-default")) {
    new Vue({
      el: '#vue-default'
    });
  }
});

function setOffset(offset, max) {
  var header = document.querySelector('.js-header');

  if (header) {
    if (document.body.classList.contains('has-scroll') && offset < max) {
      document.body.classList.remove('has-scroll');
      header.classList.remove('is-scroll');
    } else if (!document.body.classList.contains('has-scroll') && offset >= max) {
      document.body.classList.add('has-scroll');
      header.classList.add('is-scroll');
    }
  }
}

function setOffsetBackground(offset, max, background) {
  var header = document.querySelector('.js-header');

  if (header) {
    if (offset >= max && header.classList.contains('is-' + background)) {
      header.classList.remove('is-' + background);
    } else if (!header.classList.contains('is-' + background) && offset < max) {
      header.classList.add('is-' + background);
    }
  }
}

function setHeaderBg() {
  var parent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var offset = parseInt(parent.pageYOffset),
      banner = document.querySelector('.js-banner');

  if (!offset) {
    offset = parent.scrollTop;
  }

  setOffset(offset, 50);

  if (banner) {
    setOffsetBackground(offset, banner.offsetHeight - 85, banner.dataset.background);
  }
}

function initHeader() {
  var scroller = document.querySelector('.js-scroller'),
      parent = scroller ? scroller : window;

  if (scroller) {
    setHeaderBg(parent);
    parent.addEventListener("scroll", function (event) {
      return setHeaderBg(parent);
    });
    window.addEventListener("resize", function (event) {
      return setHeaderBg(parent);
    });
  }
}

function initBg() {
  var header = document.querySelector('.js-header');

  if (header) {
    var background = 'white';

    if (document.querySelector('.js-body') && document.querySelector('.js-body').dataset.background) {
      background = document.querySelector('.js-body').dataset.background;
    }

    header.classList.add("is-".concat(background));
  }
}

function setMobileHeight() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
}

setMobileHeight();
window.addEventListener('resize', function () {
  return setMobileHeight();
});
window.addEventListener("DOMContentLoaded", function (event) {
  initBg();
  initHeader();
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.addEventListener("DOMContentLoaded", function (event) {
  if (document.getElementById("vue-news")) {
    new Vue({
      el: '#vue-news',
      mixins: [eventMixin],
      data: {
        baseUrl: '/wp-json/wp/v2/',
        postType: 'posts',
        posts: null,
        postsPerPage: 10,
        page: 0,
        maxPage: null,
        filters: {
          search: '',
          categories: ''
        },
        nextIndex: 0,
        indexAdd: 5,
        options: {
          categories: []
        }
      },
      computed: {
        hasMorePosts: function hasMorePosts() {
          return !this.maxPage ? true : this.page < this.maxPage;
        },
        url: function url() {
          return this.baseUrl + this.postType;
        },
        defaultParams: function defaultParams() {
          return '?per_page=' + this.postsPerPage + '&page=' + this.page + this.langParams;
        },
        filterParams: function filterParams() {
          var _this = this;

          return Object.keys(this.filters).reduce(function (prev, curr) {
            if (_this.filters[curr]) {
              var val = _this.filters[curr],
                  strVal = _typeof(val) == 'object' ? JSON.stringify(val) : val,
                  sign = prev ? '&' : '';
              return prev + sign + curr + '=' + strVal;
            } else {
              return prev;
            }
          }, '');
        },
        params: function params() {
          return this.defaultParams + (this.filterParams ? '&' + this.filterParams : '');
        },
        hasSearch: function hasSearch() {
          return this.filterParams != '';
        },
        postsHighligthed: function postsHighligthed() {
          var nextIndex = 0,
              increment = 4,
              indexAdd = 4;
          return this.posts.map(function (p, i) {
            if (i == nextIndex) {
              nextIndex += indexAdd;
              indexAdd = indexAdd == increment ? 1 : increment;
              return true;
            }

            return false;
          });
        },
        postsNewsletter: function postsNewsletter() {
          var nextIndex = 2,
              increment = 3,
              indexAdd = 3;
          return this.posts.map(function (p, i) {
            if (i == nextIndex) {
              nextIndex += indexAdd;
              indexAdd = indexAdd == increment ? 7 : increment;
              return true;
            }

            return false;
          });
        }
      },
      mounted: function mounted() {
        if (this.$refs.containerPosts != undefined) {
          this.getCategories();
          this.getPosts();
        }
      },
      methods: {
        filter: function filter() {
          var _this2 = this;

          var delay = this.posts ? 1000 : 0;
          this.posts = null;
          this.page = 0;
          this.maxPage = null;
          this.eventHub.$emit('filters:close');
          setTimeout(function () {
            _this2.getPosts();
          }, delay);
        },
        setCategorie: function setCategorie(name, data) {
          this.options[name] = data.map(function (cat) {
            return {
              'id': cat.id,
              'name': cat.name
            };
          });
        },
        getCategories: function getCategories() {
          var _this3 = this;

          Object.keys(this.options).map(function (opt) {
            axios // avoid per_page = 10 with per_page = 100
            .get(_this3.baseUrl + opt + '?per_page=100' + _this3.langParams + '&hide_empty=true').then(function (res) {
              return _this3.setCategorie(opt, res.data);
            });
          });
        },
        updatePosts: function updatePosts(res) {
          this.posts = this.posts ? this.posts.concat(res.data) : res.data;
          this.maxPage = parseInt(res.headers['x-wp-totalpages']);
        },
        getPosts: function getPosts() {
          var _this4 = this;

          if (this.hasMorePosts) {
            this.page += 1;
            axios.get(this.url + this.params).then(function (res) {
              return _this4.updatePosts(res);
            }).catch(function (err) {
              return _this4.maxPage = _this4.page;
            });
          }
        }
      }
    });
  }
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.addEventListener("DOMContentLoaded", function (event) {
  if (document.getElementById("vue-publications")) {
    new Vue({
      el: '#vue-publications',
      mixins: [eventMixin],
      data: {
        postType: 'publication',
        posts: null,
        postsPerPage: 6,
        page: 0,
        maxPage: null,
        totalCount: 0,
        hasSearch: false,
        filters: {
          category: '',
          author: ''
        },
        options: {
          category: [],
          author: []
        }
      },
      computed: {
        hasMorePosts: function hasMorePosts() {
          return !this.maxPage ? true : this.page < this.maxPage;
        },
        url: function url() {
          return '/wp-json/wp/v2/' + this.postType;
        },
        defaultParams: function defaultParams() {
          return '?per_page=' + this.postsPerPage + '&page=' + this.page + this.langParams;
        },
        filterParams: function filterParams() {
          var _this = this;

          return Object.keys(this.filters).reduce(function (prev, curr) {
            if (_this.filters[curr]) {
              var val = _this.filters[curr],
                  strVal = _typeof(val) == 'object' ? JSON.stringify(val) : val;
              return prev + '&' + _this.postType + '_' + curr + '=' + strVal;
            } else {
              return prev;
            }
          }, '');
        },
        params: function params() {
          return this.defaultParams + (this.filterParams ? '&' + this.filterParams : '');
        },
        filterFields: function filterFields() {
          var _this2 = this;

          return Object.keys(this.options).map(function (o, i) {
            return {
              'name': o,
              'options': _this2.options[o],
              'first': o == 'category'
            };
          });
        }
      },
      mounted: function mounted() {
        if (this.$refs.containerPosts != undefined) {
          this.getCategories();
          this.getFilters();
        }
      },
      methods: {
        getFilters: function getFilters() {
          var _this3 = this;

          var search = window.location.search;

          if (!search) {
            this.filters = Object.assign(this.filters, this.retrieveFilterFromStorage(this.postType));
          } else {
            search = search.replace('?', '');
            search = search.split('&');
            search.forEach(function (s) {
              if (s) {
                var obj = s.split('='),
                    value = obj[1],
                    key = obj[0].split('_');
                key = key[1];
                _this3.filters[key] = value;
              }
            });
          }

          this.getPosts();
        },
        //update values coming from filters choices
        updateValues: function updateValues(values) {
          var _this4 = this;

          Object.keys(values).forEach(function (k) {
            _this4.filters[k] = values[k];
          });
          this.filter();
        },
        filter: function filter(filters) {
          this.filters = filters;
          this.posts = null;
          this.page = 0;
          this.maxPage = null;
          this.eventHub.$emit('filters:close');
          this.getPosts();
          this.setFilterToStorage(this.postType, this.filters);
        },
        setCategorie: function setCategorie(name, data) {
          this.options[name] = data.map(function (cat) {
            return {
              'id': cat.id,
              'name': cat.name,
              'color': cat.color
            };
          });
        },
        getCategories: function getCategories() {
          var _this5 = this;

          Object.keys(this.options).map(function (opt) {
            axios // avoid per_page = 10 with per_page = 100
            .get(_this5.url + '_' + opt + '?per_page=100' + _this5.langParams + '&hide_empty=true').then(function (res) {
              return _this5.setCategorie(opt, res.data);
            });
          });
        },
        addPage: function addPage() {
          this.page += 1;
        },
        updatePosts: function updatePosts(res) {
          this.posts = this.posts ? this.posts.concat(res.data) : res.data;
          this.maxPage = parseInt(res.headers['x-wp-totalpages']);
          this.totalCount = parseInt(res.headers['x-wp-total']);
          this.hasSearch = this.filterParams;
        },
        getPosts: function getPosts() {
          var _this6 = this;

          if (this.hasMorePosts) {
            this.addPage();
            axios.get(this.url + this.params).then(function (res) {
              return _this6.updatePosts(res);
            }).catch(function (err) {
              return _this6.maxPage = _this6.page;
            });
          }
        }
      }
    });
  }
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.addEventListener("DOMContentLoaded", function (event) {
  if (document.getElementById("vue-references")) {
    new Vue({
      el: '#vue-references',
      mixins: [eventMixin],
      data: {
        postType: 'reference',
        posts: null,
        maxPage: null,
        totalCount: 0,
        hasSearch: false,
        postsPerPage: 6,
        page: 0,
        search: '',
        filters: {
          project: '',
          region: '',
          year: '',
          competences: '',
          client: ''
        },
        options: {
          project: [],
          region: [],
          year: [],
          competences: [],
          client: []
        },
        isLoading: true
      },
      computed: {
        hasMorePosts: function hasMorePosts() {
          return !this.maxPage ? true : this.page < this.maxPage;
        },
        url: function url() {
          return '/wp-json/wp/v2/' + this.postType;
        },
        defaultParams: function defaultParams() {
          return '?per_page=' + this.postsPerPage + '&page=' + this.page + '&search=' + this.search + '&active=true' + this.langParams;
        },
        filterParams: function filterParams() {
          var _this = this;

          return Object.keys(this.filters).reduce(function (prev, curr) {
            if (_this.filters[curr]) {
              var val = _this.filters[curr],
                  strVal = _typeof(val) == 'object' ? JSON.stringify(val) : val;
              return prev + '&' + _this.postType + '_' + curr + '=' + strVal;
            } else {
              return prev;
            }
          }, '');
        },
        params: function params() {
          return this.defaultParams + (this.filterParams ? '&' + this.filterParams : '');
        }
      },
      mounted: function mounted() {
        if (this.$refs.containerPosts != undefined) {
          this.getPosts();
          this.getCategories();
        }
      },
      methods: {
        setCategorie: function setCategorie(name, data) {
          this.options[name] = data.map(function (cat) {
            return {
              'id': cat.id,
              'name': cat.name
            };
          });
        },
        getCategories: function getCategories() {
          var _this2 = this;

          Object.keys(this.options).map(function (opt) {
            axios // avoid per_page = 10 with per_page = 100
            .get(_this2.url + '_' + opt + '?per_page=100&hide_empty=true' + _this2.langParams).then(function (res) {
              return _this2.setCategorie(opt, res.data);
            });
          });
        },
        addPage: function addPage() {
          this.page += 1;
        },
        updatePosts: function updatePosts(res) {
          this.isLoading = false;
          this.posts = this.posts ? this.posts.concat(res.data) : res.data;
          this.maxPage = parseInt(res.headers['x-wp-totalpages']);
          this.totalCount = parseInt(res.headers['x-wp-total']);
          this.hasSearch = this.filterParams;
        },
        getPosts: function getPosts() {
          var _this3 = this;

          if (this.hasMorePosts) {
            this.addPage();
            axios.get(this.url + this.params).then(function (res) {
              return _this3.updatePosts(res);
            }).catch(function (err) {
              return _this3.maxPage = _this3.page;
            });
          }
        },
        filter: function filter() {
          var _this4 = this;

          if (!this.isLoading) {
            var delay = this.posts ? 300 : 0;
            this.isLoading = true;
            this.posts = [];
            this.page = 0;
            this.maxPage = null;
            setTimeout(function () {
              return _this4.getPosts();
            }, delay);
            this.eventHub.$emit('filters:close');
          }
        }
      }
    });
  }
});
"use strict";

window.addEventListener("DOMContentLoaded", function (event) {
  var button = document.getElementById('scroll-up');
  var contact = document.querySelector('.js-contact-fixed');

  if (button) {
    window.onscroll = function () {
      scrollFunction();
    };
  }

  function scrollFunction() {
    if (document.body.scrollTop > 400 || document.documentElement.scrollTop > 400) {
      button.classList.add('is-shown');

      if (contact) {
        contact.classList.add('is-left');
      }
    } else {
      button.classList.remove('is-shown');

      if (contact) {
        contact.classList.remove('is-left');
      }
    }
  }
});
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

window.addEventListener("DOMContentLoaded", function (event) {
  if (document.getElementById("vue-team")) {
    new Vue({
      el: '#vue-team',
      mixins: [eventMixin],
      data: {
        postType: 'team',
        posts: null,
        postsPerPage: 12,
        page: 0,
        maxPage: null,
        filters: {
          city: '',
          status: '',
          last_name: ''
        },
        options: {
          city: [],
          status: []
        },
        isLoading: true
      },
      computed: {
        hasMorePosts: function hasMorePosts() {
          return !this.maxPage ? true : this.page < this.maxPage;
        },
        url: function url() {
          return '/wp-json/wp/v2/' + this.postType;
        },
        defaultParams: function defaultParams() {
          return '?per_page=' + this.postsPerPage + '&page=' + this.page + '&hide_hidden=true' + this.langParams;
        },
        filterParams: function filterParams() {
          var _this = this;

          return Object.keys(this.filters).reduce(function (prev, curr) {
            if (_this.filters[curr]) {
              var val = _this.filters[curr],
                  strVal = _typeof(val) == 'object' ? JSON.stringify(val) : val;
              return prev + '&' + _this.postType + '_' + curr + '=' + strVal;
            } else {
              return prev;
            }
          }, '');
        },
        params: function params() {
          return this.defaultParams + (this.filterParams ? '&' + this.filterParams : '');
        }
      },
      mounted: function mounted() {
        if (this.$refs.containerPosts != undefined) {
          this.filters = Object.assign(this.filters, this.retrieveFilterFromStorage(this.postType));
          this.getCategories();
          this.getPosts();
        }
      },
      methods: {
        filter: function filter() {
          if (!this.isLoading) {
            this.isLoading = true;
            this.posts = null;
            this.page = 0;
            this.maxPage = null;
            this.eventHub.$emit('filters:close');
            this.getPosts();
            this.setFilterToStorage(this.postType, this.filters);
          }
        },
        setCategorie: function setCategorie(name, data) {
          this.options[name] = data.map(function (cat) {
            return {
              'id': cat.id,
              'name': cat.name
            };
          });
        },
        getCategories: function getCategories() {
          var _this2 = this;

          Object.keys(this.options).map(function (opt) {
            axios // avoid per_page = 10 with per_page = 100
            .get(_this2.url + '_' + opt + '?per_page=100' + _this2.langParams + '&hide_empty=true').then(function (res) {
              return _this2.setCategorie(opt, res.data);
            });
          });
        },
        addPage: function addPage() {
          this.page += 1;
        },
        updatePosts: function updatePosts(res) {
          this.isLoading = false;
          this.posts = this.posts ? this.posts.concat(res.data) : res.data;
          this.maxPage = parseInt(res.headers['x-wp-totalpages']);
        },
        getPosts: function getPosts() {
          var _this3 = this;

          if (this.hasMorePosts) {
            this.addPage();
            axios.get(this.url + this.params).then(function (res) {
              return _this3.updatePosts(res);
            }).catch(function (err) {
              return _this3.maxPage = _this3.page;
            });
          }
        }
      }
    });
  }
});